// src/pages/BusinessScanToEarnPage.js
import React, { useState } from 'react';
import { QrReader } from 'react-qr-reader';
import {
    QrCodeIcon,
    CameraIcon,
    XCircleIcon, HandThumbUpIcon,
} from '@heroicons/react/24/outline';

const BusinessScanToEarnPage = ({ navigateTo }) => { // Add navigateTo prop
    const [scanResult, setScanResult] = useState('');
    const [message, setMessage] = useState({ type: '', text: '' });

    const handleScan = (data) => {
        if (data) {
            setScanResult(data.text);
            // In a real app, validate the QR data and fetch client ID from backend
            // For this mock, we'll just pass the scanned data as the client ID
            navigateTo('checkout', data.text); // Navigate to checkout
        }
    };

    const handleError = (err) => {
        console.error(err);
        setMessage({ type: 'error', text: 'Error scanning QR code.' });
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-purple-500 to-indigo-600 p-4 sm:p-6 lg:p-8">
            <div className="max-w-xl mx-auto bg-white rounded-xl shadow-2xl p-6 sm:p-8 space-y-6 animate-fade-in">
                <div className="text-center">
                    <QrCodeIcon className="h-16 w-16 text-indigo-600 mx-auto mb-3" />
                    <h2 className="text-2xl font-extrabold text-gray-900">
                        Scan QR Code
                    </h2>
                    <p className="mt-1 text-md text-gray-600">
                        Scan the client's QR code to proceed with the transaction.
                    </p>
                </div>

                {/* Scanner Area */}
                <div className="border-2 border-dashed border-gray-300 rounded-lg p-2 relative bg-gray-100 flex flex-col items-center justify-center min-h-[300px]">
                    {scanResult ? (
                        <p className="text-green-600 font-bold text-lg">QR Code Scanned!</p>
                    ) : (
                        <>
                            <div className="w-full max-w-[280px] h-[280px] overflow-hidden rounded-md">
                                <QrReader
                                    onResult={handleScan}
                                    onError={handleError}
                                    constraints={{ facingMode: 'environment' }}
                                    scanDelay={500}
                                    className="w-full h-full object-cover"
                                    videoStyle={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                />
                            </div>
                            <p className="mt-4 text-gray-700 font-medium flex items-center">
                                <CameraIcon className="h-5 w-5 mr-2" />
                                Point your camera at the client's QR code.
                            </p>
                        </>
                    )}
                </div>

                {/* Messages */}
                {message.text && (
                    <div className={`p-4 rounded-md ${message.type === 'success' ? 'bg-green-100 border-green-400 text-green-700' : 'bg-red-100 border-red-400 text-red-700'} border flex items-center`}>
                        {message.type === 'success' ? (
                            <HandThumbUpIcon className="h-5 w-5 mr-2" />
                        ) : (
                            <XCircleIcon className="h-5 w-5 mr-2" />
                        )}
                        <p className="text-sm font-medium">{message.text}</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default BusinessScanToEarnPage;